/**
 * Colored badge for a payroll system / provider name.
 *
 * Uses the `brand-*` semantic tokens defined in `styles.css`. Each provider
 * maps to a family:
 *
 *   ADP         — brand-primary (indigo surface family)
 *   Paylocity   — brand-provider-paylocity (violet)
 *   SurePayroll — brand-warn (amber surface)
 *   Gusto       — brand-success (green family)
 *   unknown     — neutral draft surface (existing `--color-draft`)
 *
 * R18 migration (2026-04-19): flipped from raw `bg-[#hex]` literals to
 * semantic tokens — colors are visually identical, but a future theming
 * change is now a one-file edit in `styles.css`.
 */

const PROVIDER_BADGES: Record<string, string> = {
	ADP: "bg-brand-primary-soft text-brand-primary-on-soft",
	Paylocity: "bg-brand-provider-paylocity-soft text-brand-provider-paylocity-on-soft",
	SurePayroll: "bg-brand-warn-soft text-brand-warn-on-soft",
	Gusto: "bg-brand-success-soft text-brand-success-on-soft",
};

const NEUTRAL_BADGE = "bg-draft text-draft-text";

export type ProviderChipProps = {
	system: "ADP" | "Paylocity" | "SurePayroll" | "Gusto" | (string & {}) | null | undefined;
	className?: string;
};

export function ProviderChip({ system, className }: ProviderChipProps) {
	const label = system ?? "Unknown";
	const palette = system ? (PROVIDER_BADGES[system] ?? NEUTRAL_BADGE) : NEUTRAL_BADGE;
	const composed = className
		? `rounded px-2 py-0.5 text-xs font-medium ${palette} ${className}`
		: `rounded px-2 py-0.5 text-xs font-medium ${palette}`;
	return <span className={composed}>{label}</span>;
}
